import React, { useState } from "react";
import { api } from "../services/api.js";
import { setTokens } from "../services/auth.js";

interface LoginPageProps {
  onLogin: () => void;
}

export function LoginPage({ onLogin }: LoginPageProps): React.ReactElement {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await api.auth.login(email, password);
      setTokens(res.data.access_token, res.data.refresh_token);
      onLogin();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="gov-login" aria-labelledby="gov-login-title">
      <div className="gov-login__card">
        <div className="gov-login__body">
          <header className="gov-login__brand">
            <span className="gov-login__eyebrow" id="gov-login-context">
              Lender institution
            </span>
            <div className="gov-login__mark" aria-hidden="true">
              AE
            </div>
            <h1 className="gov-login__title" id="gov-login-title">
              Institution Portal
            </h1>
            <p className="gov-login__subtitle">
              Sign in to the Auction Ethiopia Operating System workspace
            </p>
          </header>

          <form className="gov-login__form" onSubmit={(e) => { void handleSubmit(e); }} noValidate>
            <div className="gov-login__field">
              <label className="gov-login__label" htmlFor="email">
                Email address
              </label>
              <input
                id="email"
                className="gov-login__input"
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); }}
                required
                autoComplete="email"
                autoFocus
                placeholder="name@institution.gov.et"
                aria-label="Email address"
                aria-describedby="gov-login-context"
              />
            </div>

            <div className="gov-login__field">
              <label className="gov-login__label" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                className="gov-login__input"
                type="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); }}
                required
                autoComplete="current-password"
                placeholder="Enter your password"
                aria-label="Password"
              />
            </div>

            {error !== null && (
              <div className="gov-login__error" role="alert">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="gov-login__submit"
              disabled={loading}
              aria-label="Sign in"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <p className="gov-login__footer">Authorized use only</p>
        </div>
      </div>
    </main>
  );
}
